<template>
  <div>
    <v-card
        outlined
        rounded="lg"
        class="mb-3 pa-4"
      >
        <div class="ranking-header">
          <div class="orbitron-title">
            Clasificación
          </div>

          <v-btn
            v-if="hasSeasonResult"
            class="winners-btn"
            small
            @click="openWinners"
          >
            <span
              class="material-symbols-outlined winners-btn-icon"
            >
              emoji_events
            </span>

            Ganadores
          </v-btn>
        </div>
      </v-card>

    <v-card outlined rounded="lg" class="mb-3 pa-4">
      <v-list two-line>
        <v-list-item
          v-for="(p, idx) in sortedPlayers"
          :key="p.id"
          class="ranking-player-item"
          @click="showPlayerAssets(p)"
        >
          <v-list-item-content>
            <v-list-item-title class="d-flex align-center">
              <span class="font-weight-medium mr-2">#{{ idx + 1 }}</span>

              <span
                v-if="idx === 0"
                class="material-symbols-outlined mr-1 crown-icon"
                style="color: #FFD700; font-size: 20px;"
              >
                crown
              </span>

              <span
                v-if="idx === sortedPlayers.length - 1"
                class="material-symbols-outlined mr-1 crown-icon"
                style="color: #ffaa00; font-size: 20px;"
              >
                skull
              </span>

              <span
                class="ranking-player-name"
                :class="p.id === currentPlayerId ? 'font-weight-bold' : ''"
              >
                {{ p.name }}
              </span>

              <span
                v-if="Number(p.leagueWins || 0) > 0"
                class="historical-winner"
                :title="
                  Number(p.leagueWins || 0) === 1
                    ? 'Ganador de 1 liga'
                    : `Ganador de ${p.leagueWins} ligas`
                "
              >
                <span class="material-symbols-outlined historical-winner-icon">
                  emoji_events
                </span>

                <span
                  v-if="Number(p.leagueWins || 0) > 1"
                  class="historical-winner-count"
                >
                  x{{ p.leagueWins }}
                </span>
              </span>

              <v-chip
                v-if="p.id === currentPlayerId"
                class="ml-2"
                x-small
                color="primary"
                text-color="white"
              >
                Tú
              </v-chip>
            </v-list-item-title>

            <v-list-item-subtitle>
              Producción: {{ p.totalProduction || 0 }} MW
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <div class="text-right ranking-points-block">
              <div class="ranking-total-points">
                {{ formatRankingPoints(p.points) }}
              </div>

              <div class="ranking-total-label">
                puntos totales
              </div>

              <div
                class="ranking-daily-points"
                :class="
                  Number(p.dailyPoints || 0) > 0
                    ? 'green--text'
                    : Number(p.dailyPoints || 0) < 0
                      ? 'red--text'
                      : 'grey--text'
                "
              >
                {{ formatDailyRankingPoints(p.dailyPoints) }}
                último día
              </div>
            </div>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card>
        <v-dialog
          v-model="winnersDialog"
          max-width="720px"
        >
          <v-card
            rounded="lg"
            class="winners-dialog"
          >
            <v-card-title
              class="winners-dialog-header"
            >
              <div>
                <div class="winners-title">
                  Ganadores
                </div>

                <div
                  v-if="lastSeasonResult?.season"
                  class="winners-season"
                >
                  {{ lastSeasonResult.season.leagueName }}
                  · Temporada
                  {{ lastSeasonResult.season.seasonVersion }}
                </div>
              </div>

              <v-btn
                icon
                @click="winnersDialog = false"
              >
                <span
                  class="material-symbols-outlined"
                >
                  close
                </span>
              </v-btn>
            </v-card-title>

            <v-card-text class="pa-5">
              <v-progress-linear
                v-if="loadingSeasonResult"
                indeterminate
                color="primary"
              />

              <template
                v-else-if="
                  lastSeasonResult &&
                  lastSeasonResult.classification &&
                  lastSeasonResult.classification.length
                "
              >
                <div class="podium-wrapper">
                  <div
                    v-if="podium[1]"
                    class="podium-position podium-second"
                  >
                    <div class="podium-medal">
                      🥈
                    </div>

                    <div class="podium-name">
                      {{ podium[1].username }}
                    </div>

                    <div class="podium-points">
                      {{ formatRankingPoints(
                        podium[1].points
                      ) }}
                      pts
                    </div>

                    <div
                      class="podium-block podium-block-second"
                    >
                      2
                    </div>
                  </div>

                  <div
                    v-if="podium[0]"
                    class="podium-position podium-first"
                  >
                    <div class="podium-trophy">
                      <span
                        class="material-symbols-outlined"
                      >
                        emoji_events
                      </span>
                    </div>

                    <div class="podium-name">
                      {{ podium[0].username }}
                    </div>

                    <div class="podium-points">
                      {{ formatRankingPoints(
                        podium[0].points
                      ) }}
                      pts
                    </div>

                    <div
                      class="podium-block podium-block-first"
                    >
                      1
                    </div>
                  </div>

                  <div
                    v-if="podium[2]"
                    class="podium-position podium-third"
                  >
                    <div class="podium-medal">
                      🥉
                    </div>

                    <div class="podium-name">
                      {{ podium[2].username }}
                    </div>

                    <div class="podium-points">
                      {{ formatRankingPoints(
                        podium[2].points
                      ) }}
                      pts
                    </div>

                    <div
                      class="podium-block podium-block-third"
                    >
                      3
                    </div>
                  </div>
                </div>

                <v-divider class="my-5" />

                <div class="final-ranking-title">
                  Clasificación final
                </div>

                <v-simple-table>
                  <thead>
                    <tr>
                      <th>Posición</th>
                      <th>Jugador</th>
                      <th class="text-right">
                        Puntos
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="
                        player in
                          lastSeasonResult.classification
                      "
                      :key="player.usuarioId"
                    >
                      <td>
                        #{{ player.position }}
                      </td>

                      <td>
                        <strong>
                          {{ player.username }}
                        </strong>
                      </td>

                      <td class="text-right">
                        {{
                          formatRankingPoints(
                            player.points
                          )
                        }}
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </template>

              <div
                v-else
                class="text-center grey--text py-8"
              >
                Todavía no hay una clasificación
                final disponible.
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
    <!-- Modal de Activos -->
    <v-dialog
        v-model="assetDialog"
        :max-width="$vuetify.breakpoint.smAndDown ? '96%' : '80%'"
        content-class="asset-dialog"
      >
      <v-card rounded="lg">
        <v-card-title class="headline grey lighten-4 d-flex justify-space-between align-center">
          <span class="modal-player-title">
            Activos de {{ selectedPlayer?.name }}
          </span>

          <v-btn icon @click="assetDialog = false">
            <span class="material-symbols-outlined">close</span>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
          <v-progress-linear
            v-if="loadingAssets"
            indeterminate
            color="primary"
            class="mb-4"
          />

          <div
            v-if="!loadingAssets && playerAssets.length === 0"
            class="text-center py-4"
          >
            Este usuario aún no tiene activos.
          </div>

          <v-list
            v-if="!loadingAssets && playerAssets.length > 0"
            dense
          >
            <v-list-item
              v-for="g in playerAssets"
              :key="g.id"
              class="px-0 asset-list-item"
            >
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium d-flex align-center flex-wrap asset-title-line">
            <span class="asset-name-text">
              {{ g.name }}
            </span>

            <v-btn
              icon
              x-small
              class="asset-info-btn ml-1 mr-1"
              :loading="historyLoadingId === g.id"
              title="Ver histórico de puntos"
              @click.stop="openAssetHistory(g)"
            >
              <span class="material-symbols-outlined asset-info-icon">
                info
              </span>
            </v-btn>

            <span
              v-if="g.type == 'Eólica'"
              class="material-symbols-outlined tech-icon"
            >
              mode_fan
            </span>

            <span
              v-if="g.type == 'Fotovoltaica'"
              class="material-symbols-outlined tech-icon"
            >
              solar_power
            </span>

            <span
              v-if="g.type == 'Hidráulica'"
              class="material-symbols-outlined tech-icon"
            >
              water
            </span>

            <span
              v-if="g.type == 'Nuclear'"
              class="material-symbols-outlined tech-icon"
            >
              orbit
            </span>

            <span
              v-if="g.type == 'Ciclo combinado'"
              class="material-symbols-outlined tech-icon"
            >
              factory
            </span>

            <span
              v-if="g.type == 'Carbón'"
              class="material-symbols-outlined tech-icon"
            >
              local_fire_department
            </span>

            <span class="tech-cells-badge">
              {{ getTechCells(g.type) }} celdas
            </span>
          </v-list-item-title>

                <v-list-item-subtitle>
                  {{ g.type }} · {{ g.capacity }} MW
                </v-list-item-subtitle>

                <v-list-item-subtitle class="text-caption grey--text">
                  Precio clausulazo:
                  <strong>{{ money(getPrecioClausulazo(g)) }}</strong>
                </v-list-item-subtitle>

                <v-list-item-subtitle
                  v-if="isClausulazoBloqueado(g)"
                  class="text-caption red--text"
                >
                  Protegido hasta {{ formatDateTime(g.clausulazo_bloqueado_hasta) }}
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action class="asset-list-action d-flex flex-row align-center">
                <v-btn
                  x-small
                  class="clausulazo-btn mr-2"
                  :disabled="isClausulazoBloqueado(g)"
                  :loading="clausulazoLoadingId === g.id"
                  @click.stop="confirmClausulazo(g)"
                >
                  <span class="material-symbols-outlined ml-1 v-middle" style="font-size: 14px">
                    warning
                  </span>

                  <span v-if="isClausulazoBloqueado(g)">
                    Protegido
                  </span>

                  <span v-else>
                    Clausulazo
                  </span>

                  <span class="material-symbols-outlined ml-1 v-middle" style="font-size: 14px">
                    warning
                  </span>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="assetDialog = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Fin modal de activos -->

    <!-- Modal histórico de activo -->
    <v-dialog v-model="historyDialog" max-width="560px">
      <v-card rounded="lg">
        <v-card-title class="headline grey lighten-4">
          <span class="modal-player-title">
            Histórico
          </span>
        </v-card-title>

        <v-card-text class="pa-4">
          <v-progress-linear
            v-if="loadingHistory"
            indeterminate
            color="primary"
            class="mb-4"
          />

          <div
            v-if="!loadingHistory && assetHistory.length === 0"
            class="text-center py-4 grey--text"
          >
            Este activo todavía no tiene histórico de puntos.
          </div>

          <div v-if="!loadingHistory && assetHistory.length > 0">
            <div class="text-caption grey--text mb-3">
              Últimas 5 puntuaciones registradas para este activo.
            </div>

            <v-simple-table dense>
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th class="text-right">Ganancia</th>
                  <th class="text-right">Puntos</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(h, index) in assetHistory" :key="index">
                  <td>{{ formatDate(h.fecha) }}</td>

                  <td class="text-right">
                    {{ money(h.ganancia_activo) }}
                  </td>

                  <td class="text-right">
                    <span
                      class="asset-history-points"
                      :class="Number(h.puntos_activo || 0) >= 0 ? 'green--text' : 'red--text'"
                    >
                      {{ formatPoints(h.puntos_activo) }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="historyDialog = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Fin modal histórico de activo -->
  </div>
</template>

<script>
import { useGameStore } from "@/stores/game";
import Swal from "sweetalert2";

export default {
  name: "GameRankings",

  props: {
    players: { type: Array, required: true },
    currentPlayerId: { type: String, required: true },
  },

  data() {
    return {
      store: useGameStore(),
      assetDialog: false,
      selectedPlayer: null,
      playerAssets: [],
      loadingAssets: false,
      clausulazoLoadingId: null,

      historyDialog: false,
      selectedAssetHistory: null,
      assetHistory: [],
      loadingHistory: false,
      historyLoadingId: null,
      winnersDialog: false,
      lastSeasonResult: null,
      loadingSeasonResult: false,
    };
  },

  computed: {
  hasSeasonResult() {
  return Boolean(
    this.lastSeasonResult?.hasResult
  );
},

podium() {
  const classification =
    this.lastSeasonResult?.classification;

  if (!Array.isArray(classification)) {
    return [];
  }

  return classification.slice(0, 3);
},
    sortedPlayers() {
      return [...this.players].sort((a, b) => (b.points || 0) - (a.points || 0));
    },
    activeLigaId() {
  const rawLigaId =
    this.store.currentAreaId ??
    this.store.player?.activeLigaId ??
    this.store.company?.player?.activeLigaId ??
    this.store.authUser?.active_liga_id ??
    this.store.authUser?.activeLigaId;

  const ligaId = Number(rawLigaId);

  if (!Number.isInteger(ligaId) || ligaId <= 0) {
    return null;
  }

  return ligaId;
},
  },
  watch: {
  activeLigaId(newLigaId, oldLigaId) {
    if (String(newLigaId) === String(oldLigaId)) {
      return;
    }

    this.assetDialog = false;
    this.historyDialog = false;
    this.selectedPlayer = null;
    this.selectedAssetHistory = null;
    this.playerAssets = [];
    this.assetHistory = [];
    this.loadingAssets = false;
    this.loadingHistory = false;
    this.clausulazoLoadingId = null;
    this.historyLoadingId = null;
    this.winnersDialog = false;
    this.lastSeasonResult = null;

    this.loadLastSeasonResult();
  },
},
mounted() {
  this.loadLastSeasonResult();
},

  methods: {
   formatRankingPoints(value) {
  return String(Number(value || 0));
},

formatDailyRankingPoints(value) {
  const points = Number(value || 0);

  if (points > 0) {
    return `+${points}`;
  }

  return String(points);
},
    requireActiveLigaId() {
  const ligaId = Number(this.activeLigaId);

  if (!Number.isInteger(ligaId) || ligaId <= 0) {
    throw new Error(
      "No se ha podido identificar la liga seleccionada. Vuelve a entrar en la liga."
    );
  }

  return ligaId;
},
    formatDate(v) {
  if (!v) return "-";

  const d = new Date(v);

  if (Number.isNaN(d.getTime())) return "-";

  return d.toLocaleDateString("es-ES", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
},

async openAssetHistory(asset) {
  this.selectedAssetHistory = asset;
  this.historyDialog = true;
  this.loadingHistory = true;
  this.historyLoadingId = asset.id;
  this.assetHistory = [];

  try {
    this.assetHistory = await this.store.fetchAssetHistory(asset.id);
  } catch (e) {
    Swal.fire({
      icon: "error",
      title: "No se pudo cargar el histórico",
      text: e.message || "Ha ocurrido un error inesperado.",
    });
  } finally {
    this.loadingHistory = false;
    this.historyLoadingId = null;
  }
},
    formatPoints(v) {
  const n = Number(v || 0);

  if (n > 0) return `+${n}`;

  return `${n}`;
},
    fmtEff(v) {
      if (v === null || v === undefined) return 0;
      return Math.round(Number(v) * 10) / 10;
    },

    money(v) {
      return `${Number(v || 0).toLocaleString("es-ES")} €`;
    },
    normalizarTech(type) {
  return (type || "")
    .toString()
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
},

getTechCells(type) {
  const t = this.normalizarTech(type);

  const weights = {
    eolica: 1,
    fotovoltaica: 1,
    "ciclo combinado": 3,
    hidraulica: 1,
    nuclear: 8,
    carbon: 4,
  };

  return weights[t] || 1;
},

    formatDateTime(v) {
      if (!v) return "-";

      const d = new Date(v);

      if (Number.isNaN(d.getTime())) return "-";

      return d.toLocaleString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    getPrecioClausulazo(asset) {
      if (asset.precio_clausulazo !== null && asset.precio_clausulazo !== undefined) {
        return Number(asset.precio_clausulazo);
      }

      if (asset.precio_compra !== null && asset.precio_compra !== undefined) {
        return Math.round(Number(asset.precio_compra) * 1.1);
      }

      return 0;
    },

    isClausulazoBloqueado(asset) {
      if (asset.clausulazo_bloqueado) return true;

      if (!asset.clausulazo_bloqueado_hasta) return false;

      const bloqueadoHasta = new Date(asset.clausulazo_bloqueado_hasta);

      if (Number.isNaN(bloqueadoHasta.getTime())) return false;

      return bloqueadoHasta > new Date();
    },

    async showPlayerAssets(player) {
      if (String(player.id) === String(this.currentPlayerId)) {
        this.store.activeTab = "company";
        return;
      }

      this.selectedPlayer = player;
      this.assetDialog = true;
      this.loadingAssets = true;
      this.playerAssets = [];

      try {
        const ligaId = this.requireActiveLigaId();

this.playerAssets = await this.store.fetchPlayerAssets(
  player.id,
  ligaId
);
      } catch (e) {
        alert(e.message || "No se pudieron cargar los activos del jugador");
      } finally {
        this.loadingAssets = false;
      }
    },

   async confirmClausulazo(asset) {
  const precio = this.money(this.getPrecioClausulazo(asset));

  const result = await Swal.fire({
    icon: "warning",
    title: "¿Lanzar clausulazo?",
    html: `
      <div style="text-align:left">
        <p>Vas a pagar <b>${precio}</b> por:</p>
        <p><b>${asset.name}</b></p>
        <p>El activo pasará a ser tuyo y quedará protegido durante <b>7 días</b>.</p>
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: "Sí, hacer clausulazo",
    cancelButtonText: "Cancelar",
    customClass: {
      confirmButton: "clausulazo-swal-confirm",
    },
  });

  if (!result.isConfirmed) return;

  await this.hacerClausulazo(asset);
},

async hacerClausulazo(asset) {
  this.clausulazoLoadingId = asset.id;

  try {
    const ligaId = this.requireActiveLigaId();

    const result = await this.store.clausulazoActivo(
      asset.id,
      ligaId
    );

    await Swal.fire({
      icon: "success",
      title: "Clausulazo realizado",
      text: result.message || "El activo ahora es tuyo.",
      timer: 1800,
      showConfirmButton: false,
    });

    if (this.selectedPlayer) {
      this.playerAssets = await this.store.fetchPlayerAssets(
        this.selectedPlayer.id,
        ligaId
      );
    }
  } catch (e) {
    await Swal.fire({
      icon: "error",
      title: "No se pudo hacer el clausulazo",
      text:
        e?.response?.data?.message ||
        e?.response?.data?.data?.message ||
        e?.message ||
        "Ha ocurrido un error inesperado.",
      confirmButtonText: "Entendido",
        customClass: {
          confirmButton: "clausulazo-swal-confirm",
        },
    });
  } finally {
    this.clausulazoLoadingId = null;
  }
},
async loadLastSeasonResult() {
  const ligaId = Number(
    this.activeLigaId
  );

  if (
    !Number.isInteger(ligaId) ||
    ligaId <= 0
  ) {
    this.lastSeasonResult = null;
    return;
  }

  this.loadingSeasonResult = true;

  try {
    const data =
      await this.store.fetchLastSeasonResult(
        ligaId
      );

    this.lastSeasonResult =
      data?.hasResult
        ? data
        : null;

  } catch (error) {
    console.error(
      "Error cargando resultado de temporada:",
      error
    );

    this.lastSeasonResult = null;

  } finally {
    this.loadingSeasonResult = false;
  }
},

async openWinners() {
  await this.loadLastSeasonResult();

  if (!this.lastSeasonResult) {
    return;
  }

  this.winnersDialog = true;
},
  },
};
</script>

<style scoped>
.v-middle {
  vertical-align: middle;
}

.orbitron-title {
  font-family: "Orbitron", sans-serif !important;
  font-size: 20px;
  font-weight: 600;
}
.ranking-player-item {
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.ranking-player-name {
  transition: color 0.2s ease, letter-spacing 0.2s ease;
  font-family: "Orbitron", sans-serif !important;
  font-weight: 700;
}

.ranking-player-item:hover .ranking-player-name {
  color: #31635f;
  letter-spacing: 0.4px;
}
.historical-winner {
  display: inline-flex;
  align-items: center;
  margin-left: 6px;
  color: #d4a017;
  line-height: 1;
}

.historical-winner-icon {
  font-size: 21px !important;
  color: #d4a017;
  font-variation-settings:
    "FILL" 1,
    "wght" 600,
    "GRAD" 0,
    "opsz" 24;
}

.historical-winner-count {
  margin-left: 2px;
  font-family: "Orbitron", sans-serif;
  font-size: 10px;
  font-weight: 700;
  color: #a97800;
}
.modal-player-title {
  font-family: "Orbitron", sans-serif !important;
  color: #31635f;
  font-weight: 700;
}
::v-deep .ranking-player-item {
  transition: background 0.2s ease, background-color 0.2s ease;
  border-radius: 12px;
}

::v-deep .ranking-player-item:hover {
  background: linear-gradient(
    90deg,
    rgba(191, 231, 210, 0.65),
    rgba(56, 189, 248, 0.18)
  ) !important;
}
.clausulazo-btn {
  height: 28px !important;
  padding: 0 12px !important;
  border-radius: 999px !important;
  color: #fff !important;
  font-family: "Orbitron", sans-serif !important;
  font-size: 10px !important;
  font-weight: 800;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  background: linear-gradient(135deg, #ff4d6d, #ff8a00) !important;
  box-shadow:
    0 0 10px rgba(255, 77, 109, 0.55),
    0 0 20px rgba(255, 138, 0, 0.35);
  transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
}

.clausulazo-btn:hover {
  transform: translateY(-1px) scale(1.03);
  box-shadow:
    0 0 14px rgba(255, 77, 109, 0.8),
    0 0 28px rgba(255, 138, 0, 0.5);
  filter: brightness(1.08);
}

.clausulazo-icon {
  font-size: 14px !important;
  margin: 0 4px;
}

.clausulazo-btn.v-btn--disabled {
  background: linear-gradient(135deg, #7c8a99, #4b5563) !important;
  color: rgba(255, 255, 255, 0.8) !important;
  box-shadow: none;
  opacity: 0.75;
}

.ranking-points-block {
  min-width: 125px;
}

.ranking-total-points {
  font-family: "Orbitron", sans-serif !important;
  font-size: 16px;
  font-weight: 700;
}

.ranking-total-label {
  font-family: "Orbitron", sans-serif !important;
  font-size: 10px;
  color: #757575;
}

.ranking-daily-points {
  margin-top: 4px;
  font-family: "Orbitron", sans-serif !important;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
}
.ranking-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.winners-btn {
  border-radius: 999px !important;
  padding: 0 18px !important;
  font-family: "Orbitron", sans-serif !important;
  font-size: 10px !important;
  font-weight: 700 !important;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #ffffff !important;
  background: linear-gradient(
    135deg,
    #d4a017,
    #f6c945
  ) !important;
  box-shadow:
    0 5px 14px rgba(
      212,
      160,
      23,
      0.32
    ) !important;
}

.winners-btn-icon {
  margin-right: 6px;
  font-size: 18px !important;
}

.winners-title {
  font-family: "Orbitron", sans-serif;
  font-size: 21px;
  font-weight: 700;
  color: #31635f;
}

.winners-season {
  margin-top: 3px;
  font-size: 12px;
  color: #757575;
}

.podium-wrapper {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: 12px;
  min-height: 260px;
  padding-top: 30px;
}

.podium-position {
  width: 30%;
  max-width: 175px;
  text-align: center;
  opacity: 0;
  transform: translateY(35px);
  animation:
    podium-enter 0.6s ease forwards;
}

.podium-third {
  animation-delay: 0.1s;
}

.podium-second {
  animation-delay: 0.35s;
}

.podium-first {
  animation-delay: 0.65s;
}

.podium-medal {
  font-size: 32px;
}

.podium-trophy {
  color: #d4a017;
}

.podium-trophy
.material-symbols-outlined {
  font-size: 45px !important;
  font-variation-settings:
    "FILL" 1,
    "wght" 700,
    "GRAD" 0,
    "opsz" 48;
}

.podium-name {
  margin-top: 5px;
  font-family: "Orbitron", sans-serif;
  font-size: 13px;
  font-weight: 700;
  word-break: break-word;
}

.podium-points {
  margin: 4px 0 10px;
  font-family: "Orbitron", sans-serif;
  font-size: 11px;
  color: #666666;
}

.podium-block {
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 12px 12px 0 0;

  font-family: "Orbitron", sans-serif;
  font-size: 28px;
  font-weight: 800;
  color: #ffffff;
}

.podium-block-first {
  height: 125px;
  background:
    linear-gradient(
      180deg,
      #f6c945,
      #d4a017
    );
}

.podium-block-second {
  height: 90px;
  background:
    linear-gradient(
      180deg,
      #c8c8c8,
      #8f8f8f
    );
}

.podium-block-third {
  height: 65px;
  background:
    linear-gradient(
      180deg,
      #c88955,
      #945b30
    );
}

.final-ranking-title {
  margin-bottom: 12px;

  font-family:
    "Orbitron",
    sans-serif;

  font-size: 15px;
  font-weight: 700;

  color: #31635f;
}

@keyframes podium-enter {
  from {
    opacity: 0;
    transform:
      translateY(35px)
      scale(0.94);
  }

  to {
    opacity: 1;
    transform:
      translateY(0)
      scale(1);
  }
}

@media (max-width: 600px) {
  ::v-deep .asset-dialog {
  margin: 8px !important;
}

.asset-list-item {
  align-items: flex-start !important;
  flex-wrap: wrap !important;
  padding: 10px 0 !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.asset-list-item .v-list-item__content {
  flex: 1 1 100% !important;
  width: 100% !important;
  min-width: 0 !important;
  padding: 4px 0 !important;
}

.asset-title-line {
  width: 100%;
  white-space: normal !important;
  overflow: visible !important;
}

.asset-name-text {
  max-width: none !important;
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
  word-break: break-word;
}

.asset-list-item .v-list-item__subtitle {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
}

.asset-list-action {
  flex: 1 1 100% !important;
  width: 100% !important;
  margin: 6px 0 2px !important;
  justify-content: flex-end !important;
}

.clausulazo-btn {
  margin-right: 0 !important;
}

.modal-player-title {
  font-size: 15px !important;
  line-height: 1.25;
}

.asset-list-item:last-child {
  border-bottom: none;
}
  .ranking-header {
    align-items: center;
  }

  .winners-btn {
    padding: 0 10px !important;
    font-size: 8px !important;
  }

  .podium-wrapper {
    gap: 5px;
  }

  .podium-position {
    width: 33%;
  }

  .podium-name {
    font-size: 9px;
  }

  .podium-points {
    font-size: 9px;
  }
}
</style>
<style>
.swal2-title {
  font-family: "Orbitron", sans-serif !important;
}

.swal2-popup {
  font-family: "Roboto", sans-serif !important;
}

.swal2-cancel {
  border-radius: 999px !important;
  font-family: "Orbitron", sans-serif !important;
  text-transform: uppercase;
  font-size: 12px !important;
  color: #ffffff !important;
  background: linear-gradient(135deg, #6b7280, #374151) !important;
  box-shadow:
    0 0 10px rgba(107, 114, 128, 0.35),
    0 8px 20px rgba(55, 65, 81, 0.2) !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease !important;
}

.swal2-cancel:hover {
  background: linear-gradient(135deg, #4b5563, #111827) !important;
  color: #ffffff !important;
  transform: translateY(-1px) scale(1.03);
  box-shadow:
    0 0 16px rgba(107, 114, 128, 0.55),
    0 10px 26px rgba(17, 24, 39, 0.28) !important;
  filter: brightness(1.08);
}
.asset-name-text {
  max-width: 100%;
}

.asset-info-btn {
  width: 24px !important;
  height: 24px !important;
  color: #31635f !important;
}

.asset-info-icon {
  font-size: 19px !important;
  color: #31635f;
}

.asset-info-btn:hover {
  background-color: rgba(49, 99, 95, 0.12) !important;
}

.asset-history-points {
  font-family: "Orbitron", sans-serif !important;
  font-weight: 700;
}
.asset-title-line {
  gap: 5px;
}

.tech-icon {
  font-size: 18px !important;
  color: #31635f;
  vertical-align: middle;
}

.tech-cells-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 7px;
  border-radius: 999px;
  background: rgba(49, 99, 95, 0.12);
  color: #31635f;
  border: 1px solid rgba(49, 99, 95, 0.25);
  font-size: 10px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
}
.clausulazo-swal-confirm {
  border-radius: 999px !important;
  padding: 0 18px !important;
  min-height: 36px;

  font-family: "Orbitron", sans-serif !important;
  font-size: 11px !important;
  font-weight: 800 !important;
  letter-spacing: 0.5px;
  text-transform: uppercase;

  color: #ffffff !important;
  background: linear-gradient(135deg, #ff4d6d, #ff8a00) !important;

  box-shadow:
    0 0 10px rgba(255, 77, 109, 0.55),
    0 8px 20px rgba(255, 138, 0, 0.25) !important;

  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    filter 0.2s ease !important;
}

.clausulazo-swal-confirm:hover {
  transform: translateY(-1px) scale(1.03);
  filter: brightness(1.08);

  box-shadow:
    0 0 16px rgba(255, 77, 109, 0.75),
    0 10px 26px rgba(255, 138, 0, 0.38) !important;
}
</style>